"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var _text = require("../../text");

var _closeModalContext = _interopRequireDefault(require("../close-modal-context"));

var _modalHeader = require("./modal-header.styled");

var _close = _interopRequireDefault(require("../../../icons/close"));

var _screenReader = require("../../screen-reader");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalHeader = function ModalHeader(_ref) {
  var children = _ref.children,
      hideClose = _ref.hideClose,
      props = _objectWithoutProperties(_ref, ["children", "hideClose"]);

  var contextProps = (0, _react.useContext)(_closeModalContext.default);
  return /*#__PURE__*/_react.default.createElement(_modalHeader.ModalHeaderStyled, _extends({}, contextProps, props), _react.default.Children.map(children, function (c) {
    return (0, _utils.isValidStringOrNumber)(c) ? /*#__PURE__*/_react.default.createElement(_text.Text, {
      fontWeight: "bold"
    }, c) : c;
  }), !hideClose && /*#__PURE__*/_react.default.createElement(_modalHeader.CloseButton, {
    variant: "flat",
    "data-testid": "modal-close-button",
    onClick: contextProps.onClose
  }, /*#__PURE__*/_react.default.createElement(_close.default, {
    measure: 16
  }), /*#__PURE__*/_react.default.createElement(_screenReader.SrOnly, null, _screenReader.SrLabel.CLOSE_MODAL)));
};

exports.ModalHeader = ModalHeader;